if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor () {
      super()

      this.form = this.querySelector('form')
      this.form.querySelector('[name=id]').disabled = false
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
      this.cartNotification = document.querySelector('cart-notification')
      this.submitButton = this.querySelector('[type="submit"]')
    }

    onSubmitHandler (evt) {
      evt.preventDefault()
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return

      this.handleErrorMessage()
      this.cartNotification.setActiveElement(document.activeElement)

      this.submitButton.setAttribute('aria-disabled', true)
      this.submitButton.classList.add('loading')
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden')

      const config = fetchConfig('javascript')
      config.headers['X-Requested-With'] = 'XMLHttpRequest'
      delete config.headers['Content-Type']

      const formData = new FormData(this.form)
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id))
      formData.append('sections_url', window.location.pathname)
      config.body = formData

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description)

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message')
            if (!soldOutMessage) return
            this.submitButton.setAttribute('aria-disabled', true)
            this.submitButton.querySelector('span').classList.add('hidden')
            soldOutMessage.classList.remove('hidden')
            this.error = true
            return
          }

          this.error = false
          const quickAddModal = this.closest('quick-add-modal')
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cartNotification.renderContents(response) })
            }, { once: true })
            quickAddModal.hide(true)
          } else {
            this.cartNotification.renderContents(response)
          }
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          this.submitButton.classList.remove('loading')
          if (!this.error) this.submitButton.removeAttribute('aria-disabled')
          this.querySelector('.loading-overlay__spinner').classList.add('hidden')
        })
    }

    handleErrorMessage (errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper')
      if (!this.errorMessageWrapper) return
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message')

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage)

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage
      }
    }
  })
}

// Show eco-participation variant
document.addEventListener('change', function (event) {
  const params = new URLSearchParams(window.location.search)
  const variant = params.get('variant') // Gives you access to the whole variant details
  const productEcoparticipation = document.querySelector('.ProductMeta__Ecoparticipation')
  productEcoparticipation.querySelectorAll('p').forEach(function (item) {
    item.style.display = 'none'
    if (variant === item.dataset.id) {
      item.style.display = 'block'
    }
  })
})

// Popup eco-participation
const btnEcoparticipations = document.querySelectorAll('.btn-ecoparticipation')
const popupEcoparticipation = document.querySelector('.ProductMeta__Ecoparticipation_Popup')
if (btnEcoparticipations !== null && popupEcoparticipation !== null) {
  btnEcoparticipations.forEach(function (btnEcoparticipation) {
    btnEcoparticipation.addEventListener('click', function (event) {
      popupEcoparticipation.style.display = 'block'
      event.preventDefault()
    }, false)
  })
  popupEcoparticipation.querySelector('.close').addEventListener(
    'click',
    function (event) {
      popupEcoparticipation.style.display = 'none'
      event.preventDefault()
    },
    false
  )  
}

// Popup info preorder
const btnInfopreorder = document.querySelectorAll('.btn-infopreorder')
const popupInfopreorder = document.querySelector('.ProductMeta__Infopreorder_Popup')
if (btnInfopreorder !== null && popupInfopreorder !== null) {
  btnInfopreorder.forEach(function (btnInfopreorder) {
    btnInfopreorder.addEventListener('click', function (event) {
      popupInfopreorder.style.display = 'block'
      event.preventDefault()
    }, false)
  })
  popupInfopreorder.querySelector('.close').addEventListener(
    'click',
    function (event) {
      popupInfopreorder.style.display = 'none'
      event.preventDefault()
    },
    false
  )  
}

// Color swatch
const spanSelectedValue = document.querySelector('.product-form__radios-color_swatch_selected_value')
if (spanSelectedValue !== null) {
  document.querySelector('.product-form__radios-color_swatch').querySelectorAll('input[type="radio"]').forEach(function (input) {
    if (input.checked) {
      spanSelectedValue.innerHTML = input.value;
    }
  });
  document.addEventListener('change', function (event) {
    document.querySelector('.product-form__radios-color_swatch').querySelectorAll('input[type="radio"]').forEach(function (input) {
      if (input.checked) {
        spanSelectedValue.innerHTML = input.value;
      }
    });
  });
}
